/**
 * Generated bundle index. Do not edit.
 */

export * from './trans-button-public-api';
